import { render, staticRenderFns, recyclableRender, components } from "./certification-successful.vue?vue&type=template&id=ea8115b4&scoped=true&"
var renderjs
import script from "./certification-successful.vue?vue&type=script&lang=js&"
export * from "./certification-successful.vue?vue&type=script&lang=js&"
import style0 from "./certification-successful.vue?vue&type=style&index=0&id=ea8115b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8115b4",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/certification-successful/certification-successful.vue"
export default component.exports